import { ErrorBoundary, FallbackProps } from "react-error-boundary"
import { useTranslation } from "react-i18next"
import { Card } from "../Card"
import { GET_PROJECT_SIZE } from "../../api/QuadriApi"
import { useQuery } from "@apollo/client"

const ProjectSizeInfo = (props: { quadriProjectId: string }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ProjectSizeInfoInner {...props} />
    </ErrorBoundary>
  )
}

const ProjectSizeInfoInner = (props: { quadriProjectId: string }) => {
  const { quadriProjectId } = props

  const { data, loading, error } = useQuery(GET_PROJECT_SIZE, {
    variables: { quadriProjectId }
  })

  if (error) throw error
  const projectSize = data?.getProjectSize?.project_size_pretty
  const { t } = useTranslation("config")

  return (
    <div className="row">
      <div className="col-12">
        <Card header={t("projectSize.header")}>
          <div className="col-12 col-lg-4">
            <p className="text-meta">{t("projectSize.description")}</p>
          </div>
          <div className="col-12 col-lg-8">
            <div className="row my-2">
              <div className="col-12 d-flex justify-content-between">
                <h5>{t("projectSize.databaseSize")}</h5>
              </div>
              <div className="col-12">
                <hr className="my-1" />
              </div>
              <div className="col-12 mb-1">
                <p>{projectSize}</p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

const ErrorFallback = (props: FallbackProps) => <></>

export default ProjectSizeInfo
